<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        <b-row>
          <b-col cols="6">
            <span>{{ $t('api_token.create_title') }}</span>
          </b-col>
        </b-row>
      </div>
      <div v-if="spinners.contentIsLoading" class="text-center">
        <b-spinner type="grow" variant="primary"/>
      </div>
      <div v-else>
        <b-form-group :invalid-feedback="fErr('name')">
          <label>{{ $t('api_token.name') }}</label>
          <b-form-input type="text" :placeholder="$t('api_token.name_placeholder')"
            :class="{ 'is-invalid' : fErr('name') }"
            v-model="name"/>
        </b-form-group>
      </div>
      <div slot="footer">
        <b-button type="submit" variant="primary" :disabled="spinners.isSaving" @click="save()">
          <b-spinner v-if="spinners.isSaving" type="grow" small/>
          {{ $t('global.save') }}
        </b-button>

        <b-alert class="mt-2" v-model="has_reply" dismissible>
          <div class="m-2"> {{ $dt('api_token.copy_token_info_msg','The following information won\'t be saved. Please store it in secure location!') }} </div>
          <b-form-textarea ref="token_input" :value="token_reply" readonly no-resize @click="selectToken" />
        </b-alert>
      </div>
    </b-card>
  </div>
</template>

<script>
import Services from '@/services/index';
import Vue from 'vue';

export default {
  mounted() {
  },
  data() {
    return {
      name: '',
      token_reply: '',
      has_reply: false,
      spinners: {
        contentIsLoading: false,
        isSaving: false,
      },
    };
  },
  methods: {
    save() {
      this.spinners.isSaving = true;

      Services.auth.createApiToken(this.name).then((resp) => {
        this.spinners.isSaving = false;
        this.errorMsg = {};
        this.alertSuccess();
        this.token_reply = resp.data;
        this.has_reply = true;
        this.selectToken();
      }).catch(({ errors, message }) => {
        this.spinners.isSaving = false;
        this.errorMsg = errors;
        this.alertError({ text: message });
      });
    },

    selectToken() {
      Vue.nextTick(() => {
        this.$refs.token_input.focus();
        this.$refs.token_input.select();
      });
    }
  }
};
</script>

<style scoped>
</style>
